import React, { useState } from "react";
import InfoCard from "@components/infoCard";
import Uploads from "@components/Uploads";
import { Table, message, Modal, Popconfirm } from "antd";
import {
  UploadOutlined,
  DownloadOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
// import "./index.less";


//
const DetailCard = (props) => {
  const { title, downloadFile, onSelectChange, showSignature,data,cardPath,systemNum, openModal, deleteFile, id, printFile, printSingleFile, signature, canUpload, canDelete, showPdf, sourceTree, getDoc } = props;
  const dataSource = data.map(item => ({...item, key: item.materialUrl}))
  const rowSelection = {
    onChange: (selectKeys,selectRows) => onSelectChange(id, selectRows),
    columnWidth: 30
  }
  const [visible, setVisible] = useState(false)

  const columns = [
    {
        title: '序号',
        dataIndex: 'index',
        width: '10%',
        align: 'center',
        render: (text, record, index) => {
            return index + 1;
        },
    },
    {
        title: '材料名称',
        dataIndex: 'source',
        align: 'center',
        width: '20%',
        render: (text, record) => record.materialName.split('.')[0]
    },
    {
        title: '审核状态',
        dataIndex: 'checkStatus',
        align: 'center',
        width: '20%',
        render: (text, record, index) => {
          return record.checkStatus === 0 ? '未审核' : record.checkStatus === 1 ? '审核通过' : <font title={record.checkRefuseReason}>审核不通过</font>
      }
    },
    {
        title: '操作',
        dataIndex: 'materialUrl',
        align: 'center',
        width: 'auto',
        render: (text, record) => {
            return <div style={{ color: '#A42C22', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                {/*<a href={text}>在线预览</a>*/}
                {showSignature && record.signature === 1 && <a className="preview" onClick={()=>signature(record.resID, 1)}>签名</a> }
                { record.isSeal === 1 && <a className="preview" onClick={()=>signature(record.resID, 2)}>用印</a> }
                {
                  <a onClick={()=>showPdf(text, record, 1)}>文书审核</a>
                }
                <a onClick={()=>showPdf(text, record, 2)}>在线预览</a>
                <a download={record.materialName} href={text}>下载</a>
                <a onClick={()=>printSingleFile(text)}>打印</a>
                {
                    canDelete && <Popconfirm
                        title="是否确认删除文件"
                        onConfirm={()=>deleteFile(text)}
                        okText="是"
                        cancelText="否"
                    >
                        <a>删除</a>
                    </Popconfirm>
                }
            </div>

        },
    },
  ];

  const extraBtn = () => {
    return (
      <div className="fun-btn">
        { canUpload ? <UploadOutlined onClick={() => setVisible(true)}/> : null }
        <DownloadOutlined onClick={()=>downloadFile(id)} />
        <PrinterOutlined onClick={()=>printFile(id)}/>
      </div>
    );
  };

  return (
    <InfoCard title={title} extra={extraBtn()}>
      <Table
        rowKey="resID"
        pagination={false}
        rowSelection={rowSelection}
        dataSource={dataSource}
        columns={columns}
        scroll={dataSource.length > 6 ? { y: 320, x: false } : {}}
      />
      <Modal visible={visible} footer={null} closable={false} destroyOnClose>
        <Uploads showType={id} sourceTree={sourceTree} cardPath={cardPath} systemNum={systemNum}  onCancel={() => setVisible(false)} getDoc={getDoc}/>
      </Modal>
    </InfoCard>
  );
};

export default DetailCard;
